import React, { useRef, useState } from "react";
import TextField from "@mui/material/TextField";
import Autocomplete from "@mui/material/Autocomplete";
import CircularProgress from "@mui/material/CircularProgress";
import debounce from "lodash.debounce";
import throttle from "lodash.throttle";
import { Box, Typography } from "@mui/material";

// refactor to only do search and set its selected option

// on select setSelectedBook and handleNextStep

// have setSelectedBook local state and update it after search and option select
// and at the end of step 1 and 2 then setSelectedBook to what the local state has

// have a baby component to do option select and send to it setSelectedBook or local
export default function Search({
  localSelectedBook,
  setLocalSelectedBook,
  handleNextStep,
}) {
  const [open, setOpen] = useState(false);
  const [loading, setLoading] = useState(false);
  const [options, setOptions] = useState([]);
  const previousController = useRef();
  const isUserSelection = useRef(false);

  const getData = throttle(async (searchTerm) => {
    if (!isUserSelection.current) {
      setLoading(true);

      if (previousController.current) {
        previousController.current.abort();
      }

      const controller = new AbortController();
      const signal = controller.signal;
      previousController.current = controller;

      try {
        const response = await fetch(
          `https://openlibrary.org/search.json?q=${searchTerm}&limit=20&language=eng&fields=key,author_name,title,publisher,publish_year,publish_place,edition_count,isbn,id_amazon,id_goodreads,id_librarything,id_overdrive`,
          { signal }
        );
        const myJson = await response.json();

        console.log(`Search term: ${searchTerm}, results:`, myJson?.docs);
        const data = myJson?.docs;

        const modifiedOptions = data.map((item) => {
          const [firstName, ...lastName] = item.author_name?.[0].split(" ");
          const author = [
            {
              given: firstName,
              family: lastName.join(" "),
            },
          ];

          const modifiedObj = {
            edition: item.edition_count || "",
            ISBN: item.isbn || [],
            key: item.key || "",
            "place-publisher": item.publish_place || [],
            "publisher-place": item.publish_place || [],
            issued: { "date-parts": [[item.publish_year || ""]] },
            publisher: item.publisher || [],
            title: item.title || "",
            author: author || "",
            url_ids: {
              id_amazon: item.id_amazon?.[0] || "",
              id_goodreads: item.id_goodreads?.[0] || "",
              id_librarything: item.id_librarything?.[0] || "",
            },
          };

          return modifiedObj;
        });
        setOptions(modifiedOptions);
      } catch (error) {
        console.error("Error fetching data:", error);
      } finally {
        setLoading(false);
      }
    }
  }, 1000);

  const onInputChange = debounce((event, value, reason) => {
    if (
      !isUserSelection.current &&
      value &&
      value !== localSelectedBook?.title
    ) {
      // This is a user typing, debounce the API call
      getData(value);
    }
  }, 300);

  const handleChange = (event, value) => {
    setLocalSelectedBook(value);
    isUserSelection.current = Boolean(value); // Update isUserSelection when a selection is made

    value && handleNextStep();
  };

  const renderInput = (params) => (
    <TextField
      {...params}
      label="Search Books"
      InputProps={{
        ...params.InputProps,
        endAdornment: (
          <div>
            {loading && <CircularProgress color="primary" size={20} />}
            {params.InputProps.endAdornment}
          </div>
        ),
      }}
    />
  );

  const renderOption = (props, option) => (
    <li key={option?.key} {...props}>
      <span>{option.title}</span>
    </li>
  );

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        width: "100%",
        gap: "1rem",
      }}>
      <Typography>
        Get started by searching for the book you want to cite below
      </Typography>

      <Autocomplete
        key={options.length}
        open={open}
        onOpen={() => setOpen(true)}
        onClose={() => setOpen(false)}
        getOptionLabel={(option) => option?.title}
        loading={loading}
        options={options}
        value={localSelectedBook}
        onChange={handleChange}
        onInputChange={onInputChange}
        renderInput={renderInput}
        renderOption={renderOption}
        loadingText={<>Searching...</>}
      />
    </Box>
  );
}
